/**IMPORTANT LIBRARY IMPORT */
import React from "react";


/**COMPONENT IMPORT */
import PageHero from "../Components/PageHero";



const Appointment=()=>{
    return(
        <>
         {/**HERO SECTION */}
        <PageHero heading={"Book an Appointment"}/>

        </>
    )
}

export default Appointment;